import script from "./ReportingView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportingView.vue?vue&type=script&setup=true&lang=ts"

import "./ReportingView.vue?vue&type=style&index=0&id=27797d62&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27797d62"]])

export default __exports__